import React from 'react';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import ProjectListWrapper from '../components/ProjectListWrapper/ProjectListWrapper';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'src/features/authorization';
import { Link } from 'react-router-dom';
import { PortalProjectListItemDto } from 'src/api/v2';
import usePortalProjects from '../hooks/use-portal-projects';

const OtherProjects: React.FC = () => {
  const { t: tProjects } = useTranslation('projects');
  const { t: tPageTitles } = useTranslation('pageTitles');

  const { checkAccess } = useAuth();

  const { portalProjectsQuery } = usePortalProjects();

  if (portalProjectsQuery.isFetching) {
    return <LoadingPage text={tPageTitles('ownProjects')} />;
  }

  return (
    <ContentPage title={tPageTitles('ownProjects')} hideBreadcrumbs>
      <p>
        {tProjects('portalProjectsDescription')}{' '}
        {checkAccess('DevelopmentProject').read && (
          <span>
            {tProjects('seeINProjects')}{' '}
            <Link to="/projects/in-projects">{tProjects('inFinancedProjects')}</Link>
          </span>
        )}
      </p>

      <ProjectListWrapper<PortalProjectListItemDto>
        isFetching={portalProjectsQuery.isFetching}
        projects={portalProjectsQuery.data || []}
        projectType={'other'}
      />
    </ContentPage>
  );
};

export default OtherProjects;
